module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('sex-age', {
    on: {
      "apply": _vm.apply
    }
  }), _vm._v(" "), _c('chart-data', {
    model: {
      value: (_vm.chartData),
      callback: function($$v) {
        _vm.chartData = $$v
      },
      expression: "chartData"
    }
  }), _vm._v(" "), _c('generate', {
    attrs: {
      "average": _vm.chartData.average,
      "stddev": _vm.chartData.stddev
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inst"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "alt": "身長じぇねれーた"
    }
  }), _vm._v("\n    簡単に性別、年齢に合わせたそれっぽい身長を生成するためのツールです。TRPGや創作のキャラクター作成にどうぞ。"), _c('br'), _vm._v("\n    (現在、平凡な人間の身長のみ対応しています。ケモっ子や妖精さんの身長に関する統計データをお持ちの方はご連絡ください)\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("免責/出典")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content reference"
  }, [_vm._v("\n      \n      このツールはあくまで「それっぽい」身長を作成するツールです。統計や生物学的に適切な情報を示すものではなく、自己責任でご利用ください。"), _c('br'), _vm._v("\n      ちくしょう、俺の身長は平均に達してなかった。誰も俺を愛さない。\n      "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.e-stat.go.jp/SG1/estat/GL08020103.do?_toGL08020103_&listID=000001151595&requestSender=dsearch"
    }
  }, [_vm._v("国民健康・栄養調査 平成２６年国民健康・栄養調査 年次 2014年")]), _vm._v(" 18以上の身長、標準偏差")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.e-stat.go.jp/SG1/estat/List.do?bid=000001070659&cycode=0"
    }
  }, [_vm._v("学校保健統計調査 平成２７年度 全国表 ")]), _vm._v(" 17歳以下の身長、標準偏差")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://aratama.github.io/kemonogen/"
    }
  }, [_vm._v("けものフレンズ　ロゴジェネレータ")])])]), _vm._v("\n      author : "), _c('a', {
    attrs: {
      "href": "https://twitter.com/genkuzumochi"
    }
  }, [_vm._v("くずもち@GenKuzumochi")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6481c87c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 188
// module chunks = 0